export default __webpack_public_path__ + "static/media/13.6c4851db.jpg";